import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import piniaPluginPersist from "pinia-plugin-persist"; //引入pinia数据持久化插件
import "./css/normalize.css";
import "./css/common.css";
import "vant/lib/index.css";
import "@/utils/rem";
import "element-plus/theme-chalk/index.css"; // 引入 Element Plus 样式
import "element-plus/theme-chalk/base.css";
// import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import i18n from "./i18n"; // 国际化

const app = createApp(App);
app.use(i18n);

// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component);
// }

app.use(router);
app.mount("#app");
app.use(createPinia().use(piniaPluginPersist));
